import { ButtonPrimary, ButtonTertiary, IconButton } from "@nova/component-btn"
import { TriCheckbox } from "@nova/component-checkbox"
import { Dropdown } from "@nova/component-dropdown"
import * as Icons from "@nova/component-icons"
import { ReactNode } from "react"
import classNames from "classnames"
import { ScrollableArea } from "@nova/component-scrollable-area"

const HeaderAction = ({ label, onClick }: { label: string; onClick: () => void }) => (
    <button
        type="button"
        onClick={onClick}
        className="text-gray-100 hover:text-white transition-colors shrink-0 px-3 py-1.5"
    >
        <small>{label}</small>
    </button>
)

export const FilterMenuHeader = ({
    title,
    onBack,
    onSelectAll,
    onClearAll,
}: {
    title: string
    onBack?: () => void
    onSelectAll?: () => void
    onClearAll?: () => void
}) => (
    <div className="flex items-center gap-2 pl-3 pr-1 py-1">
        {onBack && (
            <IconButton onClick={onBack} aria-label="Back" className="text-gray-300 shrink-0">
                <Icons.SmallIcon Icon={Icons.ArrowLeft} />
            </IconButton>
        )}
        <small className="flex-1 truncate text-gray-300 uppercase tracking-[1.2px]">{title}</small>
        {onSelectAll && <HeaderAction label="Select all" onClick={onSelectAll} />}
        {onClearAll && <HeaderAction label="Clear all" onClick={onClearAll} />}
    </div>
)

export const FilterMenuShell = ({
    title,
    onBack,
    onSelectAll,
    onClearAll,
    onCancel,
    onApply,
    children,
    width = "w-[280px]",
    bodyClassName = "flex flex-col py-1 max-h-[320px]",
}: {
    title: string
    onBack?: () => void
    onSelectAll?: () => void
    onClearAll?: () => void
    onCancel: () => void
    onApply: () => void
    children: ReactNode
    width?: string
    bodyClassName?: string
}) => (
    <div className={classNames("flex flex-col", width)}>
        <FilterMenuHeader
            title={title}
            onBack={onBack}
            onSelectAll={onSelectAll}
            onClearAll={onClearAll}
        />

        <ScrollableArea className={bodyClassName}>{children}</ScrollableArea>

        <div className="flex justify-end gap-2 px-3 py-2 border-t border-white-200">
            <Dropdown.Close as={ButtonTertiary} title="Cancel" onClick={onCancel} />
            <Dropdown.Close as={ButtonPrimary} title="Apply" onClick={onApply} />
        </div>
    </div>
)

export const FilterOptionRow = ({
    label,
    selected,
    disabled,
    onClick,
    leftItem,
    navigable,
    single,
}: {
    label: string
    selected?: boolean
    disabled?: boolean
    onClick?: () => void
    leftItem?: ReactNode
    navigable?: boolean
    single?: boolean
}) => (
    <button
        type="button"
        disabled={disabled}
        onClick={onClick}
        className={classNames(
            "flex items-center gap-3 w-full px-3 py-2 text-left transition-colors",
            disabled ? "text-gray-500 cursor-not-allowed" : "text-white hover:bg-gray-500"
        )}
    >
        {!navigable && !single && (
            <TriCheckbox
                state={selected ? "checked" : "unchecked"}
                size="small"
                isDisabled={disabled}
            />
        )}
        {leftItem}
        <span className="flex-1 truncate">{label}</span>
        <span className="w-5 h-5 shrink-0 flex items-center justify-center">
            {single && selected && (
                <Icons.SmallIcon Icon={Icons.Checkmark} className="text-blue-500" />
            )}
            {navigable && <Icons.SmallIcon Icon={Icons.ArrowRight} className="text-gray-300" />}
        </span>
    </button>
)
